import React, { useState, useContext, useEffect } from 'react';
import StudentListPopup from './StudentListPopup';
import ScheduleSlotPopup from './ScheduleSlotPopup';
import api from '../utils/api';
import AuthContext from '../context/AuthContext';
import { BsFiles } from "react-icons/bs";
import './styles/TransferInventoryPage.css';
import './styles/ScheduleAssign.css';
import { useNavigate } from 'react-router-dom'; 

const CLASS_TYPES = ['REGULAR', 'ENGLISH_CLUB'];

const StudentScheduleAssignPage = () => {
    const { user } = useContext(AuthContext);
    const [student, setStudent] = useState(null);
    const [classType, setClassType] = useState('');
    const [type, setType] = useState('');
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const [selectedSessions, setSelectedSessions] = useState([]);
    const [slotList, setSlotList] = useState([]);
    const [showSlotPopup, setShowSlotPopup] = useState(false);
    const [activeGroups, setActiveGroups] = useState([]);
    const [activeSessions, setActiveSessions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const navigate = useNavigate();
    
    useEffect(() => {
        if (!student?.student_id) return;
      
        api.get(`/schedule/check-active/${student.student_id}`)
            .then(async res => {
                const groups = res.data.data || [];
                setActiveGroups(groups);
          
                if (groups.length > 0) {
                    const scheduleRes = await api.get(`/schedule/student/${student.student_id}`);
                    setActiveSessions(scheduleRes.data.data || []);
                } else {
                    setActiveSessions([]);
                }
            })
            .catch(err => {
                console.error(err);
                setActiveGroups([]);
                setActiveSessions([]);
            });
    }, [student?.student_id]);

    const hasRegular = activeGroups.some(g => g.group_type.startsWith('REGULAR') || g.group_type === 'INTENSIVE');
    const hasEC = activeGroups.some(g => g.group_type === 'ENGLISH_CLUB');
    const isDisabled = (classType.startsWith('REGULAR') || classType === 'INTENSIVE') ? hasRegular : hasEC;
    
    const hasAnyActiveSchedule = activeGroups.length > 0;

    const handleSelectStudent = (s) => {
        setStudent(s);
        setShowStudentPopup(false);
        setSelectedSessions([]);
        setSlotList([]);
    };

    const handleFetchSlots = async () => {
        if (!student || !classType) return alert('Please Choose a Student and Class Type!');
        if (classType && !type) return alert('Please Choose Session Type!');
        try {
            const res = await api.get(`/schedule/slots/${student.branch_id}`);
            setSlotList(res.data.data);
            setShowSlotPopup(true);
        } catch (err) {
            console.error(err);
            alert('Gagal ambil slot guru');
        }
    };

    const handleToggleSession = (teacher_id, day, time) => {
        const key = `${teacher_id}_${day}_${time}`;
        const exists = selectedSessions.find(s => `${s.teacher_id}_${s.day_of_week}_${s.time_start}` === key);
      
        const CLASS_DAYS = {
            REGULAR: type === 'REGULAR_A' ? ['SENIN', 'RABU', 'JUMAT'] : type === 'REGULAR_B' ? ['SELASA', 'KAMIS', 'SABTU'] : ['SENIN', 'SELASA', 'RABU', 'KAMIS', 'JUMAT', 'SABTU'],
            ENGLISH_CLUB: type === 'GLOW' ? ['SENIN', 'RABU'] : ['SELASA', 'KAMIS']
        };
      
        const MAX_SLOTS = {
            REGULAR_A: 3,
            REGULAR_B: 3,
            INTENSIVE: 6,
            ENGLISH_CLUB: 2
        };
      
        const allowedDays = CLASS_DAYS[classType];
        if (!allowedDays.includes(day)) {
            alert(`Hari ${day} tidak valid untuk ${classType}`);
            return;
        }
      
        // prevent more than 1 session per day
        const alreadyPickedToday = selectedSessions.find(s => s.day_of_week === day);
        if (!exists && alreadyPickedToday) {
            alert(`Sudah ada sesi di hari ${day}, hanya boleh 1 sesi per hari`);
            return;
        }
      
        const uniqueDays = [...new Set(selectedSessions.map(s => s.day_of_week))];
        if (!exists && uniqueDays.length >= MAX_SLOTS[classType]) {
            alert(`Maksimum sesi untuk ${classType} adalah ${MAX_SLOTS[classType]}`);
            return;
        }
      
        // REGULAR_A dan REGULAR_B harus 1 guru saja
        if ((type === 'REGULAR_A' || type === 'REGULAR_B') && !exists) {
            const uniqueGuruIds = new Set([...selectedSessions.map(s => s.teacher_id), teacher_id]);
            if (uniqueGuruIds.size > 1) {
                alert(`Class ${classType} hanya boleh 1 guru untuk semua sesi`);
                return;
            }
        }

        if (type === 'INTENSIVE' && !exists) {
            const REGULAR_A_DAYS = ['SENIN', 'RABU', 'JUMAT'];
            const REGULAR_B_DAYS = ['SELASA', 'KAMIS', 'SABTU'];
            
            const tempSessions = [...selectedSessions, { teacher_id, day_of_week: day }];
            
            const guruA = new Set();
            const guruB = new Set();
          
            for (const s of tempSessions) {
              if (REGULAR_A_DAYS.includes(s.day_of_week)) {
                guruA.add(s.teacher_id);
              } else if (REGULAR_B_DAYS.includes(s.day_of_week)) {
                guruB.add(s.teacher_id);
              }
            }
          
            if (guruA.size > 1 || guruB.size > 1) {
              alert('INTENSIVE hanya boleh 1 guru di SENIN/RABU/JUMAT dan 1 guru di SELASA/KAMIS/SABTU');
              return;
            }
        }
      
        if (exists) {
            setSelectedSessions(prev => prev.filter(s => `${s.teacher_id}_${s.day_of_week}_${s.time_start}` !== key));
        } else {
            setSelectedSessions(prev => [...prev, { teacher_id, day_of_week: day, time_start: time }]);
        }
    };

    const simulateProgress = () => {
        setProgress(0);
        let percent = 0;
        const interval = setInterval(() => {
          percent += Math.random() * 10; // naik acak
          if (percent >= 100) {
            percent = 100;
            clearInterval(interval);
          }
          setProgress(Math.floor(percent));
        }, 100);
    };
      

    const handleSubmit = async () => {
        if (!student || !classType || selectedSessions.length === 0) {
            return alert('Lengkapi data terlebih dahulu');
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
        
        setIsLoading(true);
        simulateProgress();
        
        const body = {
            student_id: student.student_id,
            group_type: classType,
            type: type,
            created_by: user.username,
            sessions: selectedSessions
        };
        try {
            await api.post('/schedule/assign', body);
            const successMessage = 'Berhasil assign jadwal';
            navigate('/success', { state: { message: successMessage } });
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.error || 'Gagal assign');
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };
    
    const getTeacherName = (teacher_id) => {
        const found = slotList.find(t => t.teacher_id === teacher_id);
        return found ? found.teacher_name : `Guru #${teacher_id}`;
    };
      

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Scheduler</div>
            <div className="form-container">
                {activeGroups.length > 0 && (
                <div className="active-warning-box">
                    <strong>Perhatian:</strong> 
                    <strong>Siswa ini sudah memiliki jadwal aktif:</strong>
                    <ul style={{ margin: '5px 0 0 20px' }}>
                    {activeGroups.map((g, i) => (
                        <li key={i}>
                        {g.group_type.replace('_', ' ')}
                        </li>
                    ))}
                    </ul>
    
                    {activeSessions.length > 0 && (
                    <div style={{ marginTop: '10px' }}>
                        <strong>Detail Jadwal:</strong>
                        <table >
                            <thead>
                            <tr>
                                <th className='table-left-align'>Day</th>
                                <th className='table-left-align'>Session</th>
                                <th className='table-left-align'>Teacher</th>
                            </tr>
                            </thead>
                            <tbody>
                            {/* Tampilkan data dari costs */}
                            {activeSessions.map((s, index) => (
                                <tr key={index}>
                                    <td>{s.day}</td>
                                    <td>{s.time}</td>
                                    <td>{s.teacher?.name}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    )}
                </div>
                )}
  
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label>Student Name</label></td>
                                    <td>
                                    <div className="input-container">
                                        <input type="text" value={student?.student_name || ''} readOnly />
                                        <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                    </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Student Code</label></td>
                                    <td>
                                    <input type="text" value={student?.student_code || ''} readOnly />
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Class Type</label></td>
                                    <td>
                                    <select value={classType} onChange={(e) => setClassType(e.target.value)}>
                                        <option value="">Select</option>
                                        {CLASS_TYPES.map(ct => (
                                        <option key={ct} value={ct}>{ct.replace('_', ' ')}</option>
                                        ))}
                                    </select>
                                    </td>
                                </tr>
                                {classType === 'ENGLISH_CLUB' && (
                                    <tr>
                                    <td><label>Session Type</label></td>
                                    <td>
                                        <select value={type} onChange={e => setType(e.target.value)}>
                                        <option value="">Pilih Tipe EC</option>
                                        <option value="GLOW">EC GLOW (SENIN & RABU)</option>
                                        <option value="SHINE">EC SHINE (SELASA & KAMIS)</option>
                                        </select>
                                    </td>
                                    </tr>
                                )}
                                {classType === 'REGULAR' && (
                                    <tr>
                                    <td><label>Session Type</label></td>
                                    <td>
                                        <select value={type} onChange={e => setType(e.target.value)}>
                                            <option value="">Choose Regular Class Type</option>
                                            <option value="REGULAR_A">REGULAR_A</option>
                                            <option value="REGULAR_B">REGULAR_B</option>
                                            <option value="INTENSIVE">INTENSIVE</option>
                                        </select>
                                    </td>
                                    </tr>
                                )}
                                <tr>
                                <td><label>Pick Sessions</label></td>
                                <td>
                                    <BsFiles
                                        className={`icon ${isDisabled ? 'disabled-icon' : ''}`}
                                        onClick={() => {
                                            if (!isDisabled) handleFetchSlots();
                                        }}
                                    />
                                </td>
                                </tr>



                                {selectedSessions.length > 0 &&
                                <tr>
                                    <td><label>Selected Sessions:</label></td>
                                    <td>
                                        <div className="inventory-list">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th className='table-left-align'>Day</th>
                                                        <th className='table-left-align'>Session</th>
                                                        <th className='table-left-align'>Teacher</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedSessions.map((s, index) => (
                                                        <tr key={index}>
                                                            <td>{s.day_of_week}</td>
                                                            <td>{s.time_start}</td>
                                                            <td>{getTeacherName(s.teacher_id)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                }
                                <tr>
                                    
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>
                    <div className="search-container">
                        <button
                            className="profile-button"
                            onClick={handleSubmit}
                            disabled={isDisabled || selectedSessions.length === 0}
                            style={{
                            backgroundColor: hasAnyActiveSchedule ? '#ccc' : '#00aaff',
                            color: hasAnyActiveSchedule ? '#666' : '#fff',
                            cursor: hasAnyActiveSchedule ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
                
            </div>
  
            {showStudentPopup && (
                <StudentListPopup
                    onSelectStudent={handleSelectStudent}
                    onClose={() => setShowStudentPopup(false)}
                    branchId={user.branch_id}
                />
            )}
  
            {showSlotPopup && (
                <ScheduleSlotPopup
                    slotList={slotList}
                    selectedSessions={selectedSessions}
                    classType={classType}
                    type={type}
                    activeStudentId={student?.student_id}
                    onToggle={handleToggleSession}
                    onClose={() => setShowSlotPopup(false)}
                />
            )}

            {isLoading && (
            <div className="progress-overlay">
                <div className="progress-container">
                <div className="progress-bar" style={{ width: `${progress}%` }} />
                <div className="progress-text">{progress}%</div>
                </div>
            </div>
            )}
        </div>
    );
};

export default StudentScheduleAssignPage;
